import AccountSuspended from "../auth/AccountSuspended";
import { Box } from "@mui/material";

const OptionsAccountSuspended = () => {
  return (
    <Box className="wallet-wrapper">
      <Box className="wallet-container" height="100%">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
        >
          <AccountSuspended />
        </Box>
      </Box>
    </Box>
  );
};

export default OptionsAccountSuspended;
